import { SyncProcessLogSeverityEnum } from '../../Enums/SyncProcessLogSeverityEnum';

/**
 * Niveles de registro con los que se puede lanzar una sincronización.
 *
 * `minLogSeverity` es un **umbral**: el proceso descarta en el origen todo log
 * por debajo de ese valor. Lo que no se registró no queda en ningún lado, así
 * que después no se puede recuperar filtrando la pantalla — de ahí que la
 * decisión se tome antes de sincronizar y no al mirar el resultado.
 */
export interface SyncProcessLogLevelOption {
    severity: SyncProcessLogSeverityEnum;
    /** Clave i18n del nombre corto que ve el usuario. */
    labelKey: string;
    /** Clave i18n de la explicación de qué se guarda con este nivel. */
    descriptionKey: string;
}

/**
 * De menos a más registro. El orden del arreglo es el que se muestra: se
 * empieza por el más acotado porque es el que menos cuesta, y se termina en el
 * detallado, que es el que hay que elegir a conciencia.
 */
export const SYNC_PROCESS_LOG_LEVELS: SyncProcessLogLevelOption[] = [
    {
        severity: SyncProcessLogSeverityEnum.Error,
        labelKey: 'consumptionSyncProcess.logLevel.error.label',
        descriptionKey: 'consumptionSyncProcess.logLevel.error.description',
    },
    {
        severity: SyncProcessLogSeverityEnum.Warning,
        labelKey: 'consumptionSyncProcess.logLevel.warning.label',
        descriptionKey: 'consumptionSyncProcess.logLevel.warning.description',
    },
    {
        severity: SyncProcessLogSeverityEnum.Info,
        labelKey: 'consumptionSyncProcess.logLevel.info.label',
        descriptionKey: 'consumptionSyncProcess.logLevel.info.description',
    },
];

export const getSyncProcessLogLevel = (
    severity: SyncProcessLogSeverityEnum | undefined
): SyncProcessLogLevelOption | undefined =>
    SYNC_PROCESS_LOG_LEVELS.find((level) => level.severity === severity);

/**
 * Si una severidad quedó por debajo del umbral con el que corrió el proceso.
 * Sirve para avisar en la pantalla del log que esos eventos no se registraron,
 * en vez de mostrar un listado vacío sin explicación.
 */
export const isSeverityBelowThreshold = (
    severity: SyncProcessLogSeverityEnum,
    minLogSeverity: SyncProcessLogSeverityEnum | undefined
): boolean => minLogSeverity !== undefined && severity < minLogSeverity;
